declare var diy: any;

// This is a webpack preprocessing instruction, it is not a real variable
__webpack_public_path__ = diy.editor.jsBaseUrl;

import {App} from './App';

(new App()).init();



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/init.ts
 **/